<template>
  <div class="sorting-box-wrapper">
    <div class="sorting-box-header">
      <el-button size="mini" round :disabled="tableSelection.length < 1" @click="batchSetSortingBox">批量设置分拣箱</el-button>
    </div>
    <!-- <div>货位权限：{{ printsmodel.storage_location_batch }}</div> -->
    <el-table :data="tableData" ref="tableRef" class="sort-table" @selection-change="handleSelectionChange"
      :show-summary="false" :summary-method="getSummaries" border style="width: 100%">
      <el-table-column type="selection" width="55" fixed="left">
      </el-table-column>
      <el-table-column v-if="printsmodel.number == 1" prop="number" label="编号" width="140" fixed="left">
      </el-table-column>
      <el-table-column v-if="printsmodel.product_name == 1" prop="name" label="品名" show-overflow-tooltip width="200"
        fixed="left">
      </el-table-column>
      <el-table-column v-if="printsmodel.product_spec == 1" prop="spec" label="规格" width="70">
      </el-table-column>
      <el-table-column v-if="printsmodel.unit == 1" prop="unit" label="单位" width="70">
      </el-table-column>
      <el-table-column v-if="printsmodel.num == 1" prop="num" label="数量" width="80">
      </el-table-column>
      <el-table-column v-if="printsmodel.sell == 1" prop="sell" label="售价" width="80">
      </el-table-column>
      <el-table-column v-if="printsmodel.discount == 1" prop="discount" label="折扣" width="80">
      </el-table-column>
      <el-table-column v-if="printsmodel.dis_sell == 1" prop="dis_sell" label="折后单价">
      </el-table-column>
      <el-table-column v-if="printsmodel.market == 1" prop="market" label="零售价">
      </el-table-column>
      <el-table-column v-if="printsmodel.account == 1" prop="total" label="小计">
      </el-table-column>
      <el-table-column v-if="printsmodel.warehourse == 1" prop="warename" label="仓库" width="180">
        <template slot-scope="{row}">
          <div>{{ row.warename }}</div>
          <!-- <div v-for="item in row.storage_location" :key="item.full_code">
            {{ item.full_code }}
            <span style="color: red;">（{{ item.numbers }}）</span>
          </div> -->
        </template>
      </el-table-column>
      <el-table-column v-if="storageLocationStatus && !batchStatus && printsmodel.storage_location_batch == 1" label="货位"
        align="center" width="300">
        <template slot-scope="scope">
          <div>
            <div v-for="item in scope.row.batch_info" :key="item.storage_location_id">

              <div>
                {{ item.full_code }}
                <span style="color: #909399;">
                  [<span style="color: #F56C6C;">{{ item.total }}</span>]
                </span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column v-if="storageLocationStatus && batchStatus && printsmodel.storage_location_batch == 1" label="货位/批次"
        align="center" width="300">
        <template slot-scope="scope">

          
          <!--=========================================== 货位/批次点击dom =========================== -->
          <!--=========================================== 货位/批次点击dom =========================== -->
          <!--=========================================== 货位/批次点击dom =========================== -->
          <div>
            <div v-for="item in scope.row.batch_info" :key="item.storage_location_id">

              <div>
                {{ item.full_code }}
                <span v-if="!batchStatus" style="color: #909399;">
                  [<span style="color: #F56C6C;">{{ item.total }}</span>]
                </span>
              </div>

              <div v-if="batchStatus">
                <div style="color: #909399;" v-for="batch in item.child" :key="batch.batch_storage_inventory_id">
                  {{ batch.batch_sn }}
                  <span v-if="batch.start_date && batch.end_date">
                    [<span style="color: #F56C6C;">{{ batch.start_date }}至{{ batch.end_date }}</span>]
                  </span>
                  [<span style="color: #F56C6C;">{{ batch.numbers }}</span>]
                </div>
              </div>
            </div>
          </div>
          <!--=========================================== 货位/批次点击dom =========================== -->
          <!--=========================================== 货位/批次点击dom =========================== -->
          <!--=========================================== 货位/批次点击dom =========================== -->


        </template>
      </el-table-column>

      <el-table-column v-if="printsmodel.desc == 1" prop="desc" label="备注">
      </el-table-column>
      <el-table-column v-if="printsmodel.type == 1" prop="showtype" label="类型">
      </el-table-column>
      <el-table-column label="分拣箱/数量（0号箱为未分配）" width="300" fixed="right">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.box" :key="`${scope.row.id}` + `${index}`" class="sorting-box"
            style="">
            <el-input v-model="item.box_name" :disabled="index != scope.row.box.length - 1" size="small"
              style="width: 45px;" @blur="handleBoxNameChange(item, index, scope.row.box)"></el-input>

            <span style="flex-shrink: 0;">号箱</span>

            <el-input-number v-model="item.box_volume" style="width: 100px;" size="small" :min="1" :max="scope.row.num"
              @change="handleVolume(scope.row)"></el-input-number>

            <span style="flex-shrink: 0;">件</span>

            <span v-if="index == scope.row.box.length - 1" style="flex-shrink: 0;">/剩{{ scope.row.surplus_num }}件</span>

            <i v-if="scope.row.box.length > 1" style="cursor: pointer;" class="el-icon-remove"
              @click="removeBox(scope.row, index)"></i>

            <i v-if="index == scope.row.box.length - 1 && scope.row.surplus_num > 0"
              style="flex-shrink: 0; cursor: pointer;" class="el-icon-circle-plus" @click="addBox(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="设置分拣箱" :visible.sync="setBoxVisible" append-to-body width="300px">
      <el-input v-model="boxName" placeholder="请输入分拣箱号码，仅限数字"></el-input>
      <div style="display: flex; justify-content: space-around;margin-top: 10px;">
        <el-button @click="handleSetDialogClose">取消</el-button>
        <el-button type="primary" @click="handleSetBox">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    printsmodel: {
      type: Object,
      required: true
    },
    page: {
      type: Object,
      required: true
    },
    allPage: {
      type: String,
      required: true
    }
  },
  watch: {
    item: {
      handler(val) {
        this.getTableDataByPage(val)
      },
      // handler(val) {
      //   // this.page.id 是表示当前页码
      //   // this.allPage是表示总共有多少页
      //   // 根据以上两个信息，加上val.goods的length，计算出当前页的数据，最后赋值给this.tableData
      //   // 例子：假设this.page.id是3，也就是第3页，总共有this.allPage页，假设为5页。val.goods.length为21,那么this.tableData的数据就是val.goods[10] - val.goods[14]

      // },
      deep: true
    }
  },
  created() {
    console.log(this.printsmodel, '权限打印===============')
    this.getTableDataByPage(this.item)
    this.batchStatus = localStorage.getItem('batchStatus') === "true"
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') === "true"
  },
  data() {
    return {
      tableSelection: [],
      tableData: [],
      sortStatus: '1',
      setBoxVisible: false,
      boxName: '',
      batchStatus: false,
      storageLocationStatus: false
    }
  },
  methods: {
    handleBoxNameChange(boxItem, index, boxList) {
      // index是boxItem在boxList中的index，需要一个新数组，不包含boxItem
      const newArr = boxList.filter(item => item !== boxItem)
      const boxListNumber = newArr.map(item => item.box_name)
      const maxNumber = Number(Math.max.apply(null, boxListNumber)) + 1

      // 如果输入的不是数字
      if (isNaN(boxItem.box_name)) {
        boxItem.box_name = `${maxNumber}`
      }

      // 如果输入重复分拣箱号
      if (boxListNumber.includes(Number(boxItem.box_name))) {
        boxItem.box_name = `${maxNumber}`
      }
    },
    // 根据sortType排序
    sortTableData(val) {
      /**
       * val = 1：按照sort值顺序排序
       * val = 2：按照brand_name字段的A-Z顺序排序
       * val = 3：按照按未分配分拣箱排序，也就是只有0号分拣箱的优先排
       * val = 4：按照剩余量surplus_num倒序排序
       */
      this.tableData = this.sortDataByOption(this.tableData, val)
    },
    sortDataByOption(data, val) {
      val = Number(val);

      if (val == 3) {
        // 分离包含 box_name 为 0 和不包含的两部分数据
        const dataWithZeroBox = data.filter(item => item.box.some(box => box.box_name == 0));
        const dataWithoutZeroBox = data.filter(item => !item.box.some(box => box.box_name == 0));

        // 对 dataWithZeroBox 部分进行排序
        dataWithZeroBox.sort((a, b) => {
          // 如果 box_name 都是 0，则按 surplus_num 倒序
          return b.surplus_num - a.surplus_num;
        });

        // 对 dataWithoutZeroBox 部分进行排序
        dataWithoutZeroBox.sort((a, b) => {
          // 先按 surplus_num 倒序，如果 surplus_num 相同，则按第一个 box 的 box_name 升序
          if (b.surplus_num !== a.surplus_num) {
            return b.surplus_num - a.surplus_num;
          } else {
            const aFirstBoxName = a.box.length > 0 ? a.box[0].box_name : Infinity;
            const bFirstBoxName = b.box.length > 0 ? b.box[0].box_name : Infinity;
            return aFirstBoxName - bFirstBoxName;
          }
        });
        console.log(dataWithZeroBox, '0号箱')
        console.log(dataWithoutZeroBox, '其他号箱')

        // 合并两个部分数据
        return [...dataWithZeroBox, ...dataWithoutZeroBox];
      }

      // 其他排序选项
      return data.sort((a, b) => {
        switch (val) {
          case 1:
            return parseInt(b.sort) - parseInt(a.sort);

          case 2:
            return a.brand_name.localeCompare(b.brand_name);

          default:
            return 0;
        }
      });
    },

    getTableDataByPage(val) {
      const copyData = JSON.parse(JSON.stringify(val.goods));
      // 计算当前页的数据范围
      const startIndex = (this.page.id - 1) * this.allPage;
      const endIndex = this.page.id * this.allPage;

      // 通过 slice 方法截取当前页的数据
      this.tableData = copyData.slice(startIndex, endIndex);
      console.log(this.tableData, 'PPPPPPPPPPPPP')

    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label == '数量') {
          sums[index] = data.reduce((sum, row) => {
            return sum + Number(row[column.property]);
          }, 0);
        } else {
          sums[index] = '';
        }

        if (column.label == '小计') {
          const subtotal = data.reduce((sum, row) => {
            return Number(sum) + Number(row[column.property]);
          }, 0);
          sums[index] = subtotal.toFixed(2)
        }
      });

      return sums;
    },
    handleSelectionChange(selection) {
      this.tableSelection = selection;
    },
    handleVolume(row) {
      let total = 0
      row.box.forEach(boxItem => {
        total += boxItem.box_volume
      })
      row.surplus_num = row.num - total > 0 ? row.num - total : 0
    },
    addBox(row) {
      if (row.box.some(item => item.box_name == 0)) {
        return this.$message.error('请先分配0号箱再操作！')
      }
      this.$emit('change', true)
      let newName = 0
      row.box.forEach(boxItem => {
        // 找出boxItem中,box_name最大的值
        newName = boxItem.box_name > newName ? boxItem.box_name : newName
      })
      row.box.push({
        box_volume: 0,
        box_name: Number(newName) + 1
      })

      this.$nextTick(() => {
        // 重新计算剩余数量
        let sum = 0
        row.box.forEach(boxItem => {
          sum += Number(boxItem.box_volume)
        })
        row.surplus_num = Number(row.num) - Number(sum)
      })

    },
    removeBox(row, boxItemIndex) {
      this.$emit('change', true)
      row.box.splice(boxItemIndex, 1)
      // 获取row.box数组的box_volume总和
      this.$nextTick(() => {
        // 重新计算剩余数量
        let sum = 0
        row.box.forEach(boxItem => {
          sum += Number(boxItem.box_volume)
        })
        row.surplus_num = Number(row.num) - Number(sum)
      })
    },
    batchSetSortingBox() {
      this.setBoxVisible = true
    },
    getBoxData() {
      const arr = []
      this.tableData.forEach(item => {
        arr.push({
          product_sell_detail_id: item.id,
          sorting_box: item.box,
          surplus_num: item.surplus_num
        })
      })
      return arr
    },
    getTableData() {
      return this.tableData
    },
    inspection() {
      let isPass = true
      this.tableData.forEach(item => {
        const num = item.num

        // 获取box里的数量 box_volume，统计是否大于num
        let sum = 0
        item.box.forEach(boxItem => {
          sum += boxItem.box_volume
        })
        if (sum > num) {
          isPass = false
          this.$message.error(`编号${item.number}的分拣箱数量不能大于${num}，请修改后再打印！`)
        }
      })
      return isPass
    },
    isHaveZero() {

    },
    getBoxNames() {
      const arr = []
      this.tableData.forEach(item => {
        item.box.forEach(box => {
          arr.push(box.box_name + '')
        })

      })
      return arr
    },
    handleSetDialogClose() {
      this.boxName = ''
      this.setBoxVisible = false
      this.$refs.tableRef.clearSelection()
    },
    handleSetBox() {
      if (!this.tableSelection) {
        return
      }
      this.tableSelection.forEach(item => {
        item.box = [
          { box_name: this.boxName, box_volume: item.num }
        ]
        item.surplus_num = 0
        // if (item.surplus_num == 0) {
        //   return
        // }
        // item.box.push({
        //   box_name: this.boxName,
        //   box_volume: 1
        // })
      })
      this.setBoxVisible = false
      this.$refs.tableRef.clearSelection()
    }
  }
}
</script>
<style scoped>
.sorting-box-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 0 10px;
}

.sorting-box {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.sorting-box>>>.el-input--small .el-input__inner {
  padding: 0;
  text-align: center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.sort-table {
  border: 1px solid #30313377;
}

.sort-table>>>.el-table__header-wrapper th,
.sort-table>>>.el-table__body-wrapper td {
  border-bottom: 1px solid #30313386;
  border-right: 1px solid #30313380;
}
</style>
<style>
.sorting-box-wrapper .el-table__fixed-header-wrapper th {
  border-bottom: 1px solid #30313386;
  border-right: 1px solid #30313386;
}

.sorting-box-wrapper .el-table__fixed-header-wrapper th:last-child {
  border-right: none !important;
}

.sorting-box-wrapper .el-table__fixed-body-wrapper td {
  border-right: 1px solid #30313386;
  border-bottom: 1px solid #30313386;
}

.sorting-box-wrapper .el-table__fixed-body-wrapper td:last-child {
  border-right: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/home/SortingBox.vue